import { CircularProgress } from "react-loading-indicators";

const LoadingIndicator = ({ className, color }) => {
  return (
    <div className={`loading-indicator ${className}`}>  
      <CircularProgress size="medium" text="" color={color || "#fff"} />
    </div>
  );
};

export default LoadingIndicator;
